export const RESET_GEOFENCE_FILTER = "RESET_GEOFENCE_FILTER";
export const MODIFY_GEOFENCE_FILTER = "MODIFY_GEOFENCE_FILTER";
